<template>
  <Modal
    @close-modal="safeToClose"
  >
    <template #header>
      Video Submission For Entry {{ entry.data.SKU }}
    </template>
    <template>
      <div
        v-if="!video.isProcessing()"
        class="player"
      >
        <iframe
          class="player__iframe"
          :src="video.data.player_link"
          frameborder="0"
          allowfullscreen
        />
      </div>

      <div
        v-if="!event.data.deadline_replace_video_passed"
        class="uk-margin-top"
      >
        <ReplaceUpload
          v-show="!video.isProcessing()"
          :video="video"
          class="uk-margin"
        />

        <div class="uk-alert uk-alert-warning">
          IMPORTANT: If you replace a hyung video with a breaking video or vice versa, you must edit your entry details to match the video.
        </div>

        <div v-if="video.isProcessing()">
          <div v-if="video.isUploading()">
            Upload Progress: {{ video.upload.upload_progress }}%
          </div>
          <div
            v-if="video.isPendingConversion() || video.isConverting()"
            class="uk-alert"
          >
            Your new upload is being processed. You will receive an email once it's complete.
          </div>
        </div>
      </div>
      <div
        v-if="event.data.deadline_replace_video_passed"
        class="uk-margin-top"
      >
        <div class="uk-alert">
          {{ $t('events.deadline_replace_video_passed') }}
        </div>
      </div>
    </template>
  </Modal>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import Modal from "../misc/Modal.vue";
import EventEntryModel from "../../models/EventEntryModel";
import VideoModel from "../../models/VideoModel";
import ReplaceUpload from "../uploader/upload.vue"
import EventModel from "../../models/EventModel";

@Component({
  components: {
    Modal,
    ReplaceUpload,
  }
})
export default class PreviewVideo extends Vue {
  @Prop() entry!: EventEntryModel

  get video(): VideoModel {
    return this.entry.videos[0];
  }

  get event(): EventModel {
    return this.$store.getters['events/byId'](this.entry.data.event_id);
  }

  safeToClose(): void {
    let canClose = false;

    if (this.video.isUploading()) {
      canClose = confirm('Are you sure you want to close this window? Your upload is in progress and will be cancelled.');
    } else {
      canClose = true;
    }

    if (canClose) {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.player {
  width: 100%;
  position: relative;
  padding-top: 56.25%;
}

.player__iframe {
  border: none;
  position: absolute;
  width: 100px;
  min-width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>
